import { parse } from 'qs';
import { getReferrerPhone } from 'src/components/SalesChannel/Util';
import { cookieNames } from 'src/constants/cookieNames';
import { setCookie } from 'src/utils/Cookies';
import { ScrollDirection } from '../NavBar/NavBarUtil';

export type Referrer = {
  name: string;
  email: string;
};

export const setReferrerFromQueryParams = () => {
  const params = parse(window.location.search, { ignoreQueryPrefix: true });
  const referrerName = params.bcReferrer as string;
  const referrerEmail = params.email as string;

  if (!referrerName && !referrerEmail) return;

  const referrerObject: Referrer = { name: referrerName, email: referrerEmail };
  setCookie(cookieNames.REFERRER, JSON.stringify(referrerObject), 2);
};

export const referralInfo = (referrer: any) => {
  return {
    referrerName: referrer && referrer.name,
    referrerEmail: referrer && referrer.email,
    referrerPhone: getReferrerPhone() || undefined,
  };
};

export const transformBanner = (bannerCurrent: any, mainContentCurrent: any, navHeight: string, paddingTop: string, scrollDirection: ScrollDirection | undefined, wrapperGroupCurrent: any) => {
  const bannerHeight = `${(bannerCurrent.getBoundingClientRect().height) / 16}`;
  if (scrollDirection === ScrollDirection.DOWN) {
    bannerCurrent.style.transform = `translateY(-${bannerHeight}rem)`;
    wrapperGroupCurrent.style.transform = `translateY(${-parseFloat(navHeight.replace('rem', '')) - parseFloat(bannerHeight)}rem)`;
  } else {
    bannerCurrent.style.transform = '';
    wrapperGroupCurrent.style.transform = '';
  }
  mainContentCurrent.style.paddingTop = `${parseFloat(paddingTop.replace('rem', '')) + parseFloat(bannerHeight)}rem`;
};
